export default __webpack_public_path__ + "static/media/firstOptionNDA.png?.af0dead9";